import { render, staticRenderFns } from "./ProjectRoleAdd.vue?vue&type=template&id=7d08d6b5&scoped=true"
import script from "./ProjectRoleAdd.vue?vue&type=script&lang=js"
export * from "./ProjectRoleAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d08d6b5",
  null
  
)

export default component.exports